import React, { FC, useMemo, useState } from 'react';
import { Segment, Header, Icon, Table, Label, Form, Radio } from 'semantic-ui-react';
import { StyledContainer, Flexbox } from '@src/views/containers';
import { FlexJustify } from '@src/types';
import './styles/DashCharts.scss';
import PptxGenJS from 'pptxgenjs';
import html2canvas from 'html2canvas';

type NodeBase = {
  id: string;
  name: string;
  displayName: string;
  description?: string;
  type: 'category' | 'subcategory' | 'subobjective' | 'activity';
  startDate?: string; // YYYY-MM-DD
  endDate?: string;   // YYYY-MM-DD
  percentDone?: number;
};

type ActivityNode = NodeBase & { type: 'activity' };
type SubObjectiveNode = NodeBase & { type: 'subobjective'; children?: ActivityNode[] };
type SubCategoryNode = NodeBase & { type: 'subcategory'; children?: SubObjectiveNode[] };
type CategoryNode = NodeBase & { type: 'category'; children?: SubCategoryNode[] };

const SAMPLE_DATA: CategoryNode[] = [
  {
    "name": "CATNAME",
    "id": "C2A79F3A-3DD5-482B-B447-147CAEAC98F0",
    "description": "CatDESSC",
    "displayName": "CATNAME",
    "type": "category",
    "startDate": "2025-02-01",
    "endDate": "2026-02-01",
    "children": [
      {
        "name": "SUBCATEGORYNAMETEST2",
        "id": "F7AD990B-9674-4B85-AAA0-D539E789690E",
        "description": "SUBCATEGORYNAMETEST2",
        "displayName": "SUBCATEGORYNAMETEST2",
        "type": "subcategory",
        "startDate": "2025-02-01",
        "endDate": "2026-02-01",
        "children": [
          {
            "name": "SUBOJCTIVETESTNAME2",
            "id": "E8C9C4CD-8EA4-4355-9966-3BDB77A6B899",
            "description": "SUBOJCTIVETESTNAME2",
            "displayName": "SUBOJCTIVETESTNAME2",
            "type": "subobjective",
            "startDate": "2025-12-15",
            "endDate": "2026-01-15",
            "percentDone": 0,
            "children": [
              {
                "id": "EA6F3F01-B0E1-4881-A3BF-CA48BC7693E2",
                "name": "ActivityName1",
                "displayName": "ActivityName1",
                "startDate": "2025-12-15",
                "endDate": "2026-01-15",
                "percentDone": 0,
                "type": "activity"
              },
              {
                "id": "61940C0E-89F5-4BBE-A569-E6F7BC301FC4",
                "name": "ActivityName2",
                "displayName": "ActivityName2",
                "startDate": "2025-12-15",
                "endDate": "2026-01-15",
                "percentDone": 0,
                "type": "activity"
              },
              {
                "id": "61940C0E-89F5-4BBE-A569-E6F7BC301FC4",
                "name": "ActivityName3",
                "displayName": "ActivityName3",
                "startDate": "2025-12-15",
                "endDate": "2026-01-15",
                "percentDone": 0,
                "type": "activity"
              },
              {
                "id": "61940C0E-89F5-4BBE-A569-E6F7BC301FC4",
                "name": "ActivityName4",
                "displayName": "ActivityName4",
                "startDate": "2025-12-15",
                "endDate": "2026-01-15",
                "percentDone": 0,
                "type": "activity"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "name": "CategoryName",
    "id": "9DE3B4D8-9083-4CD9-8C2E-A0B630A2C076",
    "description": "CategoryDescription",
    "displayName": "CategoryName",
    "type": "category",
    "startDate": "2025-02-01",
    "endDate": "2026-02-01",
    "children": [
      {
        "name": "SubCategoryName",
        "id": "E524951A-927A-4726-BB25-77BAA04CACDF",
        "description": "SubCategoryDescription",
        "displayName": "SubCategoryName",
        "type": "subcategory",
        "startDate": "2025-02-01",
        "endDate": "2026-02-01",
        "children": [
          {
            "name": "SubObjectiveName",
            "id": "321F44BC-2A98-403D-9D93-EFE49C831C6A",
            "description": "SubObjectiveDescription",
            "displayName": "SubObjectiveName",
            "type": "subobjective",
            "startDate": "2025-10-24",
            "endDate": "2025-12-28",
            "percentDone": 0,
            "children": [
              {
                "id": "70F3C0C6-8ED9-47A2-B990-C17521DAA3B4",
                "name": "ActivityName",
                "displayName": "ActivityName",
                "startDate": "2025-10-24",
                "endDate": "2025-11-18",
                "percentDone": 0,
                "type": "activity"
              },
              {
                "id": "E30FF28F-4C06-454B-9F5F-665AF411456A",
                "name": "ActivityName2",
                "displayName": "ActivityName2",
                "startDate": "2025-11-23",
                "endDate": "2025-12-28",
                "percentDone": 0,
                "type": "activity"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "name": "CATNAME",
    "id": "9762CFED-715F-420F-BD3E-FFF9406F7C37",
    "description": "CatDESSC",
    "displayName": "CATNAME",
    "type": "category",
    "startDate": "2025-02-01",
    "endDate": "2026-02-01",
    "children": [
      {
        "name": "SUBCATEGORYNAMETEST2",
        "id": "95503672-1FB2-4782-BADE-2DEE5EA58A4C",
        "description": "SUBCATEGORYNAMETEST2",
        "displayName": "SUBCATEGORYNAMETEST2",
        "type": "subcategory",
        "startDate": "2025-02-01",
        "endDate": "2026-02-01",
        "children": [
          {
            "name": "SUBOJCTIVETESTNAME2",
            "id": "60EF5569-258D-4D5D-AE0E-90B49E108FD0",
            "description": "SUBOJCTIVETESTNAME2",
            "displayName": "SUBOJCTIVETESTNAME2",
            "type": "subobjective",
            "startDate": "2025-12-15",
            "endDate": "2026-01-15",
            "percentDone": 0,
            "children": [
              {
                "id": "B6F0EACF-F0CF-408E-A733-2C21EBA560C9",
                "name": "ActivityName3",
                "displayName": "ActivityName3",
                "startDate": "2025-12-15",
                "endDate": "2026-01-15",
                "percentDone": 0,
                "type": "activity"
              }
            ]
          }
        ]
      }
    ]
  }
];


type Level = 'SubCategory' | 'Objective' | 'Activity';
type Framing = 'Yearly' | 'Quarterly' | 'Monthly';

const dt = (s?: string) => (s ? new Date(s + 'T00:00:00Z') : undefined);
const clamp = (v: number, a = 0, b = 1) => Math.max(a, Math.min(b, v));
const dateMin = (a?: Date, b?: Date) => (a && b ? (a < b ? a : b) : a || b);
const dateMax = (a?: Date, b?: Date) => (a && b ? (a > b ? a : b) : a || b);

const lastOfMonth = (y: number, m0: number) => new Date(Date.UTC(y, m0 + 1, 0, 23, 59, 59, 999));
const yearSpan = (y: number) => ({ start: new Date(Date.UTC(y, 0, 1)), end: new Date(Date.UTC(y, 11, 31, 23, 59, 59, 999)) });
const quarterSpan = (y: number, q: 1 | 2 | 3 | 4) => {
  const m0 = (q - 1) * 3;
  return { start: new Date(Date.UTC(y, m0, 1)), end: lastOfMonth(y, m0 + 2) };
};
const monthSpan = (y: number, m0: number) => ({ start: new Date(Date.UTC(y, m0, 1)), end: lastOfMonth(y, m0) });

const overlaps = (a0: Date, a1: Date, b0: Date, b1: Date) => a0 <= b1 && b0 <= a1;
const overlapFraction = (a0: Date, a1: Date, b0: Date, b1: Date) => {
  const s = a0 > b0 ? a0 : b0;
  const e = a1 < b1 ? a1 : b1;
  if (e <= s) return 0;
  return clamp((e.getTime() - s.getTime()) / (b1.getTime() - b0.getTime()));
};

// New: compute both fraction and offset (position of the overlap within the span)
const overlapInfo = (a0?: Date, a1?: Date, b0?: Date, b1?: Date) => {
  if (!a0 || !a1 || !b0 || !b1) return { frac: 0, offset: 0 };
  const s = a0 > b0 ? a0 : b0;
  const e = a1 < b1 ? a1 : b1;
  if (e <= s) return { frac: 0, offset: 0 };
  const total = b1.getTime() - b0.getTime();
  const frac = clamp((e.getTime() - s.getTime()) / total);
  const offset = clamp((s.getTime() - b0.getTime()) / total);
  return { frac, offset };
};
const enumerate = <T,>(n: number, fn: (i: number) => T) => Array.from({ length: n }, (_, i) => fn(i));

/** Collect activities */
const actsInSubCategory = (sc: SubCategoryNode): ActivityNode[] => (sc.children ?? []).reduce<ActivityNode[]>((acc, so) => {
  (so.children ?? []).forEach(a => acc.push(a));
  return acc;
}, []);
const actsInObjective = (so: SubObjectiveNode): ActivityNode[] => (so.children ?? []);

/** Roll-up range from activities */
const rollupRangeFromActivities = (acts: ActivityNode[]) => {
  let s: Date | undefined; let e: Date | undefined;
  acts.forEach(a => { s = dateMin(s, dt(a.startDate)); e = dateMax(e, dt(a.endDate)); });
  return { start: s, end: e };
};

/** Global min/max year based on activity dates (most accurate) */
const globalYearRange = (cats: CategoryNode[]) => {
  let minY: number | undefined, maxY: number | undefined;
  cats.forEach(c => (c.children ?? []).forEach(sc => (sc.children ?? []).forEach(so => (so.children ?? []).forEach(a => {
    const s = dt(a.startDate); const e = dt(a.endDate);
    if (s) minY = minY === undefined ? s.getUTCFullYear() : Math.min(minY, s.getUTCFullYear());
    if (e) maxY = maxY === undefined ? e.getUTCFullYear() : Math.max(maxY, e.getUTCFullYear());
  }))));
  const y0 = minY ?? new Date().getUTCFullYear();
  const y1 = Math.max(maxY ?? y0, y0);
  return { y0, y1 };
};


export const DashGanttView: FC = () => {
  const [ level, setLevel ]     = useState<Level>('Objective'),
        [ framing, setFraming ] = useState<Framing>('Quarterly');

  const catRefs = React.useRef<Record<string, HTMLDivElement | null>>({});

  const { years } = useMemo(() => {
    const { y0, y1 } = globalYearRange(SAMPLE_DATA);
    return { years: enumerate(y1 - y0 + 1, i => y0 + i) };
  }, []);

  return (
    <StyledContainer className="dash-gantt-view">
      <Segment padded="very" className="dash-gantt-controls">
        <Header as="h3" className="dash-gantt-controls-title">
          <Icon name="settings" />
          <Header.Content>View Options</Header.Content>
        </Header>

        <Form>
          <Form.Group widths="equal">
            <Form.Field>
              <label className="dash-gantt-field-label">Level</label>
              <Flexbox justify={FlexJustify.START} className="dash-gantt-radio-row">
                {(['SubCategory', 'Objective', 'Activity'] as Level[]).map(val => (
                  <Form.Field key={val}>
                    <Radio
                      label={val}
                      name="levelRadios"
                      checked={level === val}
                      onChange={() => setLevel(val)}
                    />
                  </Form.Field>
                ))}
              </Flexbox>
            </Form.Field>

            <Form.Field>
              <label className="dash-gantt-field-label">Framing</label>
              <Flexbox justify={FlexJustify.START} className="dash-gantt-radio-row">
                {(['Yearly', 'Quarterly', 'Monthly'] as Framing[]).map(val => (
                  <Form.Field key={val}>
                    <Radio
                      label={val}
                      name="frameRadios"
                      checked={framing === val}
                      onChange={() => setFraming(val)}
                    />
                  </Form.Field>
                ))}
              </Flexbox>
            </Form.Field>

            <Form.Field className="dash-gantt-export-field">
              <label className="dash-gantt-field-label--hidden">Export</label>
              <Icon
                name="file powerpoint"
                size="huge"
                color="red"
                className="dash-gantt-export-icon"
                title="Export to PowerPoint (screenshot style)"
                onClick={async () => {
                  const pptx = new PptxGenJS();

                  const renderCategoryToCanvas = async (catEl: HTMLDivElement) => {
                    try {
                      const canvas = await html2canvas(catEl, { backgroundColor: '#fff', scale: 2 });
                      return canvas;
                    } catch (err) {
                      return null;
                    }
                  };

                  for (const cat of SAMPLE_DATA) {
                    const rows: any[] = buildRowsForCategory(cat, level) || [];
                    const catEl = catRefs.current[cat.id];

                    if (!rows || rows.length === 0) {
                      const s = pptx.addSlide();
                      s.addText(cat.displayName || cat.name, { x: 0.5, y: 0.3, fontSize: 18, bold: true });
                      s.addText('No data', { x: 0.5, y: 1.0, fontSize: 14 });
                      continue;
                    }

                    if (catEl) {
                      const srcCanvas = await renderCategoryToCanvas(catEl);
                      if (srcCanvas) {
                        const table = catEl.querySelector('table');
                        const thead = table?.querySelector('thead') as HTMLElement | null;
                        const tbody = table?.querySelector('tbody') as HTMLElement | null;
                        const firstRow = tbody?.querySelector('tr') as HTMLElement | null;

                        const catRect = catEl.getBoundingClientRect();
                        const tableRect = table ? (table as HTMLElement).getBoundingClientRect() : catRect;
                        const theadRect = thead ? thead.getBoundingClientRect() : { height: 60 } as DOMRect;
                        const rowHeight = firstRow ? firstRow.getBoundingClientRect().height : 28;

                        const ratioY = srcCanvas.height / catRect.height;

                        const tableTopOffset = tableRect.top - catRect.top; // px from top of catEl
                        const headerEl = catEl.querySelector('h2') as HTMLElement | null;
                        const headerRect = headerEl ? headerEl.getBoundingClientRect() : { top: catRect.top, height: 0 } as DOMRect;
                        const headerTopOffset = headerRect.top - catRect.top;

                        const rowsPerSlide = 12;

                        for (let rowStart = 0; rowStart < rows.length; rowStart += rowsPerSlide) {
                          const sliceCount = Math.min(rowsPerSlide, rows.length - rowStart);

                          const tableHeaderDomPx = theadRect.height;
                          const sliceBottomDom = tableTopOffset + tableHeaderDomPx + sliceCount * rowHeight;
                          const sliceHeightDomPx = sliceBottomDom - headerTopOffset;

                          const srcY = Math.round(headerTopOffset * ratioY);
                          const srcH = Math.min(Math.round(sliceHeightDomPx * ratioY), srcCanvas.height - srcY);
                          if (srcH <= 0) continue;

                          const outCanvas = document.createElement('canvas');
                          outCanvas.width = srcCanvas.width;
                          outCanvas.height = srcH;
                          const ctx = outCanvas.getContext('2d')!;

                          ctx.drawImage(srcCanvas, 0, srcY, srcCanvas.width, srcH, 0, 0, outCanvas.width, outCanvas.height);

                          const imgData = outCanvas.toDataURL('image/png');
                          const slide = pptx.addSlide();
                          slide.addImage({ data: imgData, x: 0.25, y: 0.25, w: 9.5, h: (outCanvas.height / outCanvas.width) * 10 });
                        }

                        continue; // next category
                      }
                    }

                    const maxPerSlide = 12;
                    for (let i = 0; i < rows.length; i += maxPerSlide) {
                      const chunk = rows.slice(i, i + maxPerSlide);
                      const slide = pptx.addSlide();

                      slide.addText(cat.displayName || cat.name, { x: 0.5, y: 0.2, fontSize: 18, bold: true });
                      slide.addText(`${cat.startDate ?? '—'} → ${cat.endDate ?? '—'}`, { x: 0.5, y: 0.6, fontSize: 12 });

                      const leftColsLocal = level === 'SubCategory' ? ['Subcategory'] : level === 'Objective' ? ['Subcategory', 'Objective'] : ['Subcategory', 'Objective', 'Activity'];
                      const columns = [...leftColsLocal, 'Start', 'End'];
                      const tableRows = chunk.map(r => [
                        r.subcategory ?? '',
                        r.objective ?? '',
                        r.activity ?? '',
                        r.range?.start ? r.range.start.toISOString().slice(0,10) : '—',
                        r.range?.end ? r.range.end.toISOString().slice(0,10) : '—'
                      ].slice(0, columns.length));

                      const headerRow = columns.map(c => ({ text: c, options: { bold: true } } as any));
                      const tableData = [
                        headerRow,
                        ...tableRows.map(tr => tr.map(cell => ({ text: String(cell) })))
                      ];

                      slide.addTable(tableData as any, {
                        x: 0.5,
                        y: 1.1,
                        w: 9,
                        colW: Array(columns.length).fill(9 / columns.length),
                        border: { type: 'solid', color: '000000', pt: 1 },
                        fontSize: 12
                      });
                    }
                  }

                  await pptx.writeFile({ fileName: 'GanttExport.pptx' });
                }}
              />
             </Form.Field>
           </Form.Group>
         </Form>
       </Segment>

      {SAMPLE_DATA.map((cat) => (
        <Segment key={cat.id} padded="very" className="dash-gantt-category">
          <StyledContainer ref={el => (catRefs.current[cat.id] = el)}>
            <Header as="h2" color="teal" className="dash-gantt-category-header">
              <Icon name="lab" />
              <span>{cat.displayName || cat.name}</span>
              <Label basic color="teal" className="dash-gantt-category-range">
                {(cat.startDate ?? '—')} → {(cat.endDate ?? '—')}
              </Label>
            </Header>

            <TimeGridTable
              category={cat}
              years={years}
              level={level}
              framing={framing}
            />
          </StyledContainer>
        </Segment>
      ))}
    </StyledContainer>
  );
};


const TimeGridTable: FC<{
  category: CategoryNode;
  years: number[];
  level: Level;
  framing: Framing;
}> = ({ category, years, level, framing }) => {

  const headerCells = useMemo(() => {
    if (framing === 'Yearly') {
      return years.map((y) => ({ key: `Y-${y}`, label: String(y) }));
    }
    if (framing === 'Quarterly') {
      return years.reduce((acc: { key: string; label: string }[], y) => {
        acc.push({ key: `Y-${y}-Q1`, label: `${y} Q1` });
        acc.push({ key: `Y-${y}-Q2`, label: `${y} Q2` });
        acc.push({ key: `Y-${y}-Q3`, label: `${y} Q3` });
        acc.push({ key: `Y-${y}-Q4`, label: `${y} Q4` });
        return acc;
      }, []);
    }
    const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return years.reduce((acc: { key: string; label: string }[], y) => {
      months.forEach((m, i) => acc.push({ key: `Y-${y}-M${i+1}`, label: `${y} ${m}` }));
      return acc;
    }, []);
  }, [years, framing]);

  type Row = {
    key: string;
    subcategoryId?: string;
    subcategory?: string;
    objectiveId?: string;
    objective?: string;
    activity?: string;
    range?: { start?: Date; end?: Date };
  };

  const { rows, subcatInfo, objInfo } = useMemo(() => {
    const out: Row[] = [] as Row[];
    const subcatInfo: Record<string, { first: number; span: number; name: string }> = {};
    const objInfo: Record<string, { first: number; span: number; name: string }> = {};

    (category.children ?? []).forEach((sc) => {
      if (level === 'SubCategory') {
        const acts = actsInSubCategory(sc);
        const { start, end } = rollupRangeFromActivities(acts);
        const idx = out.length;
        out.push({ key: sc.id, subcategoryId: sc.id, subcategory: sc.displayName || sc.name, range: { start, end } });
        subcatInfo[sc.id] = { first: idx, span: 1, name: sc.displayName || sc.name };
        return;
      }

      if (level === 'Objective') {
        const objectives = sc.children ?? [];
        objectives.forEach((so) => {
          const acts = actsInObjective(so);
          const { start, end } = rollupRangeFromActivities(acts);
          const idx = out.length;
          out.push({ key: so.id, subcategoryId: sc.id, subcategory: sc.displayName || sc.name, objectiveId: so.id, objective: so.displayName || so.name, range: { start, end } });

          if (!subcatInfo[sc.id]) subcatInfo[sc.id] = { first: idx, span: 0, name: sc.displayName || sc.name };
          subcatInfo[sc.id].span += 1;

          if (!objInfo[so.id]) objInfo[so.id] = { first: idx, span: 1, name: so.displayName || so.name };
        });
        return;
      }

      const objectives = sc.children ?? [];
      objectives.forEach((so) => {
        const acts = so.children ?? [];
        acts.forEach((a) => {
          const idx = out.length;
          out.push({
            key: a.id,
            subcategoryId: sc.id,
            subcategory: sc.displayName || sc.name,
            objectiveId: so.id,
            objective: so.displayName || so.name,
            activity: a.displayName || a.name,
            range: { start: dt(a.startDate), end: dt(a.endDate) }
          });

          if (!subcatInfo[sc.id]) subcatInfo[sc.id] = { first: idx, span: 0, name: sc.displayName || sc.name };
          subcatInfo[sc.id].span += 1;

          if (!objInfo[so.id]) objInfo[so.id] = { first: idx, span: 0, name: so.displayName || so.name };
          objInfo[so.id].span += 1;
        });
      });
    });

    return { rows: out, subcatInfo, objInfo };
  }, [category, level]);

  const leftCols = useMemo(() => {
    if (level === 'SubCategory') return ['Subcategory'];
    if (level === 'Objective')   return ['Subcategory', 'Objective'];
    return ['Subcategory', 'Objective', 'Activity'];
  }, [level]);

  return (
    <Table celled basic="very" compact="very">
      <Table.Header>
        <Table.Row>
          {leftCols.map((h) => (
            <Table.HeaderCell key={h} className="dash-gantt-th">
              {h}
            </Table.HeaderCell>
          ))}
          {headerCells.map(h => (
            <Table.HeaderCell
              key={h.key}
              textAlign="center"
              className="dash-gantt-th-period"
            >
              {h.label}
            </Table.HeaderCell>
          ))}
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {rows.length === 0 ? (
          <Table.Row>
            <Table.Cell colSpan={leftCols.length + headerCells.length} className="dash-gantt-empty">
              No data
            </Table.Cell>
          </Table.Row>
        ) : (
          rows.map((r, rowIndex) => (
            <Table.Row key={`${level}-${r.key}-${rowIndex}`}>
              {leftCols.map((col) => {
                if (col === 'Subcategory') {
                  if (level === 'SubCategory') {
                    return (
                      <Table.Cell key={`sub-${r.key}`} className="dash-gantt-cell--bold">
                        <StyledContainer className="dash-gantt-cell--left">{r.subcategory}</StyledContainer>
                      </Table.Cell>
                    );
                  }

                  if (r.subcategoryId && subcatInfo[r.subcategoryId]) {
                    const info = subcatInfo[r.subcategoryId];
                    if (info.first === rowIndex) {
                      return (
                        <Table.Cell
                          key={`sub-${r.key}`}
                          rowSpan={info.span}
                          className="dash-gantt-cell--bold dash-gantt-cell--left"
                        >
                          {info.name}
                        </Table.Cell>
                      );
                    }
                    return null;
                  }

                  return <Table.Cell key={`sub-${r.key}`} className="dash-gantt-cell" />;
                }

                if (col === 'Objective') {
                  if (level === 'Objective') {
                    return (
                      <Table.Cell key={`obj-${r.key}`} className="dash-gantt-cell">
                        {r.objective}
                      </Table.Cell>
                    );
                  }

                  if (level === 'Activity') {
                    if (r.objectiveId && objInfo[r.objectiveId]) {
                      const info = objInfo[r.objectiveId];
                      if (info.first === rowIndex) {
                        return (
                          <Table.Cell
                            key={`obj-${r.key}`}
                            rowSpan={info.span}
                            className="dash-gantt-cell dash-gantt-cell--left"
                          >
                            {info.name}
                          </Table.Cell>
                        );
                      }
                      return null;
                    }

                    return <Table.Cell key={`obj-${r.key}`} className="dash-gantt-cell" />;
                  }

                  return null;
                }

                if (col === 'Activity') {
                  if (level === 'Activity') {
                    return (
                      <Table.Cell key={`act-${r.key}`} className="dash-gantt-cell">
                        {r.activity}
                      </Table.Cell>
                    );
                  }
                  return null;
                }

                return null;
              })}

              {framing === 'Yearly' &&
                years.map(y => {
                  const span = yearSpan(y);
                  const info = overlapInfo(r.range?.start, r.range?.end, span.start, span.end);
                  return (
                    <Table.Cell key={`cell-${r.key}-Y${y}`} className="dash-gantt-bar-cell">
                      <StyledContainer className="dash-gantt-bar-track">
                        <StyledContainer className="dash-gantt-bar-fill dash-gantt-bar-fill--full" style={{
                            left: `${Math.round(info.offset * 100)}%`,
                            width: `${Math.max(0, Math.round(info.frac * 100))}%`,
                          }}
                          title={`${Math.round(info.frac * 100)}% of ${y}`}
                        />
                        <StyledContainer className="dash-gantt-bar-label">
                          {info.frac > 0 ? `${Math.round(info.frac * 100)}%` : ''}
                        </StyledContainer>
                      </StyledContainer>
                    </Table.Cell>
                  );
                })}

              {framing === 'Quarterly' &&
                years.reduce<JSX.Element[]>((acc, y) => {
                  (['Q1','Q2','Q3','Q4'] as const).forEach((qLabel, idx) => {
                    const q = (idx + 1) as 1 | 2 | 3 | 4;
                    const span = quarterSpan(y, q);
                    const info = overlapInfo(r.range?.start, r.range?.end, span.start, span.end);
                    acc.push(
                      <Table.Cell
                        key={`cell-${r.key}-${y}-${qLabel}`}
                        textAlign="center"
                        className="dash-gantt-bar-cell"
                        title={info.frac > 0 ? `${Math.round(info.frac * 100)}% of ${qLabel} ${y}` : ''}
                      >
                        <StyledContainer className="dash-gantt-bar-track">
                          {info.frac > 0 ? (
                            <StyledContainer className="dash-gantt-bar-fill" style={{
                                left: `${Math.round(info.offset * 100)}%`,
                                width: `${Math.max(0, Math.round(info.frac * 100))}%`,
                              }}
                            />
                          ) : null}
                        </StyledContainer>
                      </Table.Cell>
                    );
                  });
                  return acc;
                }, [])}

              {framing === 'Monthly' &&
                years.reduce<JSX.Element[]>((acc, y) => {
                  enumerate(12, m0 => {
                    const span = monthSpan(y, m0);
                    const info = overlapInfo(r.range?.start, r.range?.end, span.start, span.end);
                    acc.push(
                      <Table.Cell
                        key={`cell-${r.key}-${y}-M${m0+1}`}
                        textAlign="center"
                        className="dash-gantt-bar-cell"
                        title={info.frac > 0 ? `${Math.round(info.frac * 100)}% of ${y}-${m0+1}` : ''}
                      >
                        <StyledContainer className="dash-gantt-bar-track">
                          {info.frac > 0 ? (
                            <StyledContainer className="dash-gantt-bar-fill" style={{
                                left: `${Math.round(info.offset * 100)}%`,
                                width: `${Math.max(0, Math.round(info.frac * 100))}%`,
                              }}
                            />
                          ) : null}
                        </StyledContainer>
                      </Table.Cell>
                    );
                    return null;
                  });
                  return acc;
                }, [])}
            </Table.Row>
          ))
        )}
      </Table.Body>
    </Table>
  );
};

// Helper to build rows for a category (same logic as TimeGridTable rows)
const buildRowsForCategory = (category: CategoryNode, level: Level) => {
  type Row = {
    key: string;
    subcategory?: string;
    subcategoryId?: string;
    objective?: string;
    objectiveId?: string;
    activity?: string;
    range?: { start?: Date; end?: Date };
  };
  const out: Row[] = [];

  (category.children ?? []).forEach(sc => {
    if (level === 'SubCategory') {
      const acts = actsInSubCategory(sc);
      const { start, end } = rollupRangeFromActivities(acts);
      out.push({ key: sc.id, subcategoryId: sc.id, subcategory: sc.displayName || sc.name, range: { start, end } });
      return;
    }

    if (level === 'Objective') {
      const objectives = sc.children ?? [];
      objectives.forEach(so => {
        const acts = actsInObjective(so);
        const { start, end } = rollupRangeFromActivities(acts);
        out.push({ key: so.id, subcategoryId: sc.id, subcategory: sc.displayName || sc.name, objectiveId: so.id, objective: so.displayName || so.name, range: { start, end } });
      });
      return;
    }

    const objectives = sc.children ?? [];
    objectives.forEach(so => {
      const acts = so.children ?? [];
      acts.forEach(a => {
        out.push({
          key: a.id,
          subcategoryId: sc.id,
          subcategory: sc.displayName || sc.name,
          objectiveId: so.id,
          objective: so.displayName || so.name,
          activity: a.displayName || a.name,
          range: { start: dt(a.startDate), end: dt(a.endDate) }
        });
      });
    });
  });

  return out;
};

export default DashGanttView;